<script lang="ts" setup>
import { ref, onMounted, reactive, getCurrentInstance } from "vue";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";

import "leaflet/dist/leaflet.css";
import AUApi from "@/api";
import * as L from "leaflet";
import {
  checkAndInitializeMap,
  fitMapBounds,
  flyMapTo,
  MapMarker,
  MapPolyLine,
  unbindMapFromSite,
} from "../MapHelper";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "./EditComponentStatic";
import { useRegisterValidation } from "@/components/EditorValidator";
declare interface EditGPSProps extends EditControlProps {
  standort?: { lat: number; lng: number; name: string };
  showMap?: boolean;
}
const props = defineProps<EditGPSProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

declare interface Adresse {
  street?: string;
  plz?: string;
  city?: string;
  name?: string;
  lat: number;
  lng: number;
  anzeige: string;
  checked?: boolean;
  bundesland?: string;
  land?: string;
  nr?: string;
  subtitle?: string;
  kz?: string;
  id?: string;
  info?: boolean;
}
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
const uiData = reactive(ui);
const zoom = ref<number>(13);
//config.validate = validate;

// basemap.at - mal anschauen - gratis!
let Abflatlong!: any[];
let Anklatlong!: any[];
let kmAnzeige!: string;
let Abfahrtsort!: string;
let Ankunftsort!: string;
let lat = ref(47.92525);
let lng = ref(16.87635);
let ortLayer: any = L.layerGroup();
let initalized = ref<boolean>(false);
let mymap: L.Map | undefined;
let popup: L.Popup | undefined;
let showAdresse: boolean = false;
let adresse = ref("");
let edit = ref<boolean>(true);
let addresseAPICall = ref<Adresse[]>([]);
let searchTimeout: ReturnType<typeof setTimeout> | null = null;
let searchText = ref<string>("");
let componentKey = ref<number>(0);
let menuKey = ref<number>(0);
let loading = ref<boolean>(false);
let menu = ref(false);
let showOkButton = ref<boolean>(false);
const activatorRef = ref();
let form = reactive({
  Land: "AT",
  PLZ: "",
  Ort: "",
  Strasse: "",
});

config.validate = validate;
useRegisterValidation({ config });

function validate() {
  return uiData.required
    ? uiData.data && uiData.data.lat && uiData.data.lng
      ? true
      : false
    : true;
}

onMounted(async () => {
  mounted(uiData, props, config);
  if (config?.column?.meta.suche) {
    edit.value = true;
    // initalized.value = true;
    // return;
  } else {
    edit.value = false;
  }
  if (!showAdresse && !props.showMap) {
    lat.value = 0;
    lng.value = 0;
  }
  const initValue = config.initValue;
  if (props.showMap) {
    searchText.value = "";
    edit.value = true;
  }
  if (initValue) {
    lat.value = initValue.lat;
    lng.value = initValue.lng;
    adresse.value = initValue.name;
    if (initValue.kz) {
      form.Land = initValue.kz;
    }
    if (initValue.plz) {
      form.PLZ = initValue.plz;
    }
    if (initValue.ort) {
      form.Ort = initValue.ort;
    }
    if (initValue.street) {
      form.Strasse = initValue.street;
    }
    showAdresse = true;
    if (props.showMap) {
      searchText.value = adresse.value;
    }
  }
  const logo = L.icon({
    iconUrl: "map_marker.png",
    iconSize: [41, 41],
    iconAnchor: [21, 41],
  });
  const marker: MapMarker[] = [];
  const lines: MapPolyLine[] = [];
  let bounds: [[number, number], [number, number]] | undefined;
  if (showAdresse) {
    marker.push({
      lat: initValue.lat,
      long: initValue.lng,
      icon: logo,
      text: initValue.name ?? "Adresse",
    });
  } else if (props.standort) {
    (lat.value = props.standort.lat),
      (lng.value = props.standort.lng),
      (adresse.value = props.standort.name);
    marker.push({
      lat: props.standort.lat,
      long: props.standort.lng,
      icon: logo,
      text: "Standort",
    });
  } else {
    if (Abflatlong && Anklatlong) {
      marker.push(
        {
          lat: Abflatlong[0],
          long: Abflatlong[1],
          text: "Abfahrtsort: " + Abfahrtsort,
        },
        {
          lat: Anklatlong[0],
          long: Anklatlong[1],
          text: "Ankunftsort: " + Ankunftsort,
        }
      );

      bounds = [
        [Abflatlong[0], Abflatlong[1]],
        [Anklatlong[0], Anklatlong[1]],
      ];

      lines.push({
        points: [
          [Abflatlong[0], Abflatlong[1]],
          [Anklatlong[0], Anklatlong[1]],
        ],
        color: "green",
        weight: 10,
        opacity: 1,
        text: "",
      });
    }
  }
  if (edit.value) {
    return;
  }
   const instance = getCurrentInstance();
  if (instance) {
  let mapContainer = ref<HTMLDivElement | null>(null);
  mapContainer.value = instance.proxy?.$refs.map as any;
  if (mapContainer.value) {
    const container = checkAndInitializeMap(lat.value, lng.value, mapContainer.value, {
      marker,
      lines,
    });
  }}
  initalized.value = true;
  // console.log("showing lines:" + JSON.stringify(lines));
  // console.log("showing marker:" + JSON.stringify(marker));
  if (bounds) {
    fitMapBounds(bounds!);
  } else if (props.standort) {
    flyMapTo([props.standort.lat, props.standort.lng]);
  } else if (showAdresse) {
    flyMapTo([lat.value, lng.value], 10);
  }
});
function unmounted() {
  unbindMapFromSite();
}
function beforeUnmount() {
  unbindMapFromSite();
}
function beforeDestroy() {
  unbindMapFromSite();
  // if (mymap) {
  //   mymap.remove();
  // }
}

//  layer = L.marker([lat, long], { icon: icon })
//   .addTo(mymap)
//   .bindPopup("I am here.")
//   .openPopup();
//  circle = L.circle([lat, long], {
//   color: "grey",
//   fillColor: "#f03",
//   fillOpacity: 0.5,
//   radius: 100
// }).addTo(mymap);
//  popup = L.popup() // extra popup - zB für Firmenadresse interessant...
//   .setLatLng([lat, long])
//   .setContent("I am a standalone popup.")
//   .openOn(mymap);‚
function onMapClick(e?: any) {
  console.log("markierte Position:" + e);

  if (mymap && e) {
    if (popup) {
      popup
        .setLatLng(e.latlng)
        .setContent("<p>" + e.latlng.lat + "," + e.latlng.lng + "</p>")
        .openOn(mymap);
    }
  }
}

async function findSearch(val: Adresse) {
  loading.value = true;
  addresseAPICall.value = [];
  if (searchText.value || form.Ort || form.PLZ) {
    let response = undefined;
    if ((form && form.Ort) || form.PLZ) {
      // if (!form.Land) {
      //   form.Land = "AT";
      // }
      response = await AUApi.Current.getAdressAPICall(
        "",
        form.PLZ,
        form.Ort,
        form.Strasse,
        "20",
        form.Land
      );
      menu.value = false;
    } else {
      response = await AUApi.Current.getAdressAPICall(
        searchText.value,
        "",
        "",
        "",
        "20",
        ""
      );
    }
    if (response.data.msgType == "Error") {
      const message = response.data.info;
      loading.value = false;
      alert(message);
      return;
    } else {
      for (let i = 0; i < response.data.data.length; i++) {
        const address = response.data.data[i];
        let nummer = "";
        if (address.nr !== undefined) {
          nummer = address.nr;
        }
        let subtitle = "";
        if (address.street !== undefined) {
          subtitle = address.street + " " + nummer;
        }

        let anzeige = "";
        if (address.plz !== undefined) {
          anzeige = address.plz + " " + address.ort;
        } else if (address.kz !== undefined) {
          anzeige = address.kz + ", " + address.ort;
        }

        addresseAPICall.value.push({
          street: address.street || "", // Straße
          plz: address.plz || "", // PLZ
          city: address.ort || "", // Stadt oder Dorf
          name: address.name, // Behalte das ursprüngliche `display_name` für die Anzeige
          lat: address.lat,
          lng: address.lng,
          anzeige,
          land: address.land,
          bundesland: address.bundesland,
          subtitle,
          nr: nummer,
          kz: address.kz,
          id: address.id,
          info: false,
        });
      }
      componentKey.value += 1;
      loading.value = false;
    }
  } else {
    alert("bitte eine Adresse angeben!");
    loading.value = false;
  }
}
function checkChanged(gv: any) {
  showOkButton.value = false;
  gv.checked = !gv.checked;

  let nurInitalisierung = false;
  if (uiData.readonly) {
    nurInitalisierung = true;
  }
  if (gv.checked) {
    showOkButton.value = true;
    searchText.value = gv.name;
    uiData.data = gv;
    valueChanged(config, uiData, uiData.data, nurInitalisierung);
  } else {
    showOkButton.value = false;
  }
}
function selectionFinished() {
  const valueList = addresseAPICall.value.filter(
    (c: any) => c.checked === true
  );
  if (valueList.length === 0) {
    searchText.value = "";
    config.emit("change", {});
  }
  showOkButton.value = false;
  addresseAPICall.value = [];
}

function clearAll() {
  showOkButton.value = false;
  searchText.value = "";
  form = { Land: "AT", PLZ: "", Ort: "", Strasse: "" };
  menuKey.value += 1;
  config.emit("change", {});
}
// function selectedValueChanged(data: any, ausInit?: boolean) {
//   const val = selected;

//   valueChanged(config, uiData, val);
// }
</script>
<template>
  <v-container v-if="uiData.showMutable" class="wrap pa-0">
    <v-tooltip
      v-if="edit"
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-row class="pa-0 ma-0" v-bind="props">
          <v-text-field
            :label="uiData.description"
            v-model="searchText"
            clearable
            persistent-hint
            :error-messages="uiData.errorText"
            :required="uiData.required"
            @click:clear="clearAll"
          >
            <template v-slot:prepend-inner>
              <v-fade-transition leave-absolute>
                <v-progress-circular
                  v-if="loading"
                  color="info"
                  size="24"
                  indeterminate
                ></v-progress-circular>
              </v-fade-transition>
            </template>
            <template v-slot:append>
              <v-btn
                variant="text"
                color="primary"
                @click="findSearch"
                class="mt-2"
                icon="mdi-search-web"
              >
              </v-btn>
            </template>
            <template v-slot:append-inner>
              <v-btn
                ref="activatorRef"
                variant="text"
                color="primary"
                class="mt-2"
                icon="mdi-chevron-down"
                @click="menu = !menu"
              />
            </template>
          </v-text-field>
        </v-row>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>

    <v-card
      v-if="menu"
      :key="menuKey"
      color="surface-variant"
      class="pa-0 mx-0 my-2"
      variant="outlined"
      density="compact"
      title="detailierte Suche"
    >
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field v-model="form.Land" label="Land" />
          </v-col>
          <v-col>
            <v-text-field v-model="form.PLZ" label="PLZ" />
          </v-col>
        </v-row>

        <v-text-field v-model="form.Ort" label="Ort" />
        <v-text-field v-model="form.Strasse" label="Strasse" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="clearAll"
          color="primary"
          class="mt-2"
          icon="mdi-cancel"
        ></v-btn>
        <v-btn
          @click="findSearch"
          color="primary"
          class="mt-2"
          icon="mdi-search-web"
        ></v-btn>
        <v-btn
          @click="menu = !menu"
          color="primary"
          class="mt-2"
          icon="mdi-close"
        ></v-btn>
      </v-card-actions>
    </v-card>

    <v-card
      color="surface-variant"
      class="pa-0 mx-0 my-2"
      v-if="addresseAPICall.length > 0"
      title="gefundene Orte"
      variant="outlined"
      density="compact"
    >
      <v-list :key="componentKey" lines="two">
        <v-list-item
          v-for="(gv, iix) in addresseAPICall"
          :key="'gv' + iix"
          :subtitle="gv.subtitle"
          :title="gv.anzeige"
          @click="checkChanged(gv)"
        >
          <template v-slot:prepend>
            <v-icon v-if="!gv.checked">mdi-checkbox-blank-outline</v-icon>
            <v-icon color="primary" v-if="gv.checked"
              >mdi-checkbox-outline</v-icon
            >
          </template>
          <template v-slot:append>
            <v-menu
              v-model="gv.info"
              open-on-click
              top
              offset-y
              :close-on-click="true"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  color="grey-lighten-1"
                  icon="mdi-information"
                  variant="text"
                  v-bind="props"
                >
                </v-btn>
              </template>
              <v-card min-width="400px" title="Adresse:" v-if="gv.info">
                <v-card
                  variant="outlined"
                  density="compact"
                  color="surface-variant"
                  class="ma-2"
                >
                  <v-card-title class="d-block pa-3">
                    <div
                      class="text-body-2"
                      style="
                        max-width: 300px;
                        white-space: normal;
                        word-wrap: break-word;
                      "
                    >
                      {{ gv.name }}
                    </div></v-card-title
                  >
                  <v-card-text>
                    <div>Land: {{ gv.land }}</div>
                    <div>Bundesland: {{ gv.bundesland }}</div>
                    <div>PLZ: {{ gv.plz }}</div>
                    <div>Ort: {{ gv.city }}</div>

                    <div v-if="gv.subtitle">Strasse: {{ gv.subtitle }}</div>
                    <!-- <div>name: {{ gv.name }}</div> -->
                  </v-card-text>
                </v-card>
                <EditGps
                  :standort="{ lat: gv.lat, lng: gv.lng, name: '' }"
                ></EditGps>

                <v-divider></v-divider>
                <v-card-actions color="white" class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    variant="text"
                    color="success"
                    icon="mdi-close"
                    @click.stop="gv.info = false"
                  ></v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </template>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions color="white" class="pa-0">
        <v-spacer></v-spacer>

        <v-btn
          variant="text"
          color="success"
          icon="mdi-close"
          @click="selectionFinished()"
        ></v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-if="
        uiData.showMutable &&
        (props.standort || lat > 0) &&
        !edit &&
        !props.showMap
      "
    >
      <v-card-text v-if="lat > 0">{{ adresse }}</v-card-text>
      lat: {{ lat }} lng: {{ lng }}
      <div style="height:300px; width:100%">
        <l-map ref="map" v-model:zoom="zoom"  :center="[lat, lng]">
          <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            layer-type="base"
            name="OpenStreetMap"
          ></l-tile-layer>
          <l-marker :lat-lng="[lat, lng]"></l-marker>
        </l-map>
      </div>
    </v-card>
    <!-- <div v-else>kein Standort anzuzeigen</div> -->
  </v-container>
</template>
<style scoped>
#mapid {
  height: 400px;
  width: 100%;
}
.v-input--horizontal .v-input__prepend {
  margin-inline-end: 0px;
}
</style>
